/**
 * Barre de navigation des 6 sous-onglets du rapport cabinet.
 * Sticky sous la navbar principale. Slugs FR alignés avec les routes
 * `/espace-client/rapport-mensuel/:period/:section`.
 */

const TABS = [
  { key: 'lettre', label: 'Lettre & synthèse' },
  { key: 'activite', label: 'Activité commerciale' },
  { key: 'rentabilite', label: 'Rentabilité' },
  { key: 'stock', label: 'Stock & trésorerie' },
  { key: 'patientele', label: 'Patientèle & services' },
  { key: 'plan-action', label: "Plan d'action" },
];

export default function ReportSubNav({ currentSection, onChange }) {
  return (
    <div
      className="border-b border-cabinet-border bg-cabinet-cream sticky top-[73px] z-40"
      data-testid="report-subnav"
    >
      <div className="max-w-5xl mx-auto px-8">
        <nav className="flex gap-8 overflow-x-auto" style={{ scrollbarWidth: 'none' }}>
          {TABS.map((tab) => {
            const isActive = currentSection === tab.key;
            return (
              <button
                key={tab.key}
                onClick={() => onChange(tab.key)}
                data-testid={`report-tab-${tab.key}`}
                className={`py-4 text-[12px] font-medium tracking-wide transition border-b-2 -mb-px whitespace-nowrap ${
                  isActive
                    ? 'border-cabinet-bordeaux text-cabinet-bordeaux'
                    : 'border-transparent text-cabinet-ink-secondary hover:text-cabinet-ink'
                }`}
              >
                {tab.label}
              </button>
            );
          })}
        </nav>
      </div>
    </div>
  );
}
